import * as React from "react";
import { createPortal } from "react-dom";

const loadingPanelMarkup = (
  <div className="k-loading-mask" style={{ zIndex: 99999999999 }}>
    <span className="k-loading-text">Loading</span>
    <div className="k-loading-image" />
    <div className="k-loading-color" />
  </div>
);

export const LoadingPanel = (props: any) => {
  const { gridRef } = props;
  const gridContent =
    gridRef.current && gridRef.current.querySelector(".k-grid-content");
  return gridContent
    ? createPortal(loadingPanelMarkup, gridContent)
    : loadingPanelMarkup;
};
